import axios from 'axios';
import { API } from '@/constants';
import { paramsHandler } from '@/utils';

const nftApi = {
  /**
   *
   * @param {string} token
   * @param {string} contractAddress
   * @param {string} id
   * @returns {AxiosPromise}
   */
  requestDetail({ token, contractAddress, id }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      url: `/${contractAddress}/tokens/${id}`,
      method: 'get',
      baseURL: API.ROUTE.NFT,
      headers,
    });
  },
  /**
   *
   * @param {string} token
   * @param {object} params
   * @returns {AxiosPromise}
   */
  requestList(token, params) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      method: 'get',
      baseURL: API.ROUTE.NFT,
      headers,
      params: paramsHandler.bindValuedParams(params),
    });
  },
  /**
   *
   * @param {string} token
   * @param {object} data
   * @returns {AxiosPromise}
   */
  requestTransfer(token, data) {
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    return axios({
      method: 'post',
      baseURL: API.ROUTE.NFT,
      headers,
      data,
    });
  },
};

export default nftApi;
